import { Component } from '@angular/core';
import { HostingService } from '../../services/hosting.service';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-tenant-home',
  imports: [],
  templateUrl: './tenant-home.component.html',
  styleUrl: './tenant-home.component.css'
})
export class TenantHomeComponent {

  alojamiento: any;
  customPageSafeUrl?: SafeResourceUrl;

  urlHTML: string = 'https://turismo-rural-colombia-filespages.s3.us-east-1.amazonaws.com/index.html';

  constructor(
    private route: ActivatedRoute,
    private hostingService: HostingService,
    private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    const slug = this.route.snapshot.paramMap.get('slug') || '';
    this.hostingService.getHosting(slug).subscribe(data => {
      this.alojamiento = data;
      if (this.urlHTML) {
        // supongamos que el JSON del alojamiento tiene "custom_page_url" apuntando al HTML externo
        this.customPageSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.urlHTML);
      }
    })
  }
}
